var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"preloader-container"},[_c('img',{staticClass:"preloader",attrs:{"src":require("@/assets/images/ched/icons/ched-70px.png"),"width":"70px;","height":"70px;"}}),_c('span',{staticClass:"loading-text"},[_vm._v(" "+_vm._s(_vm.loading_text)+" ")]),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }